import {useMemo} from "react";
import {Link} from "react-router-dom";

import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";

import {sortShiftPropertiesPrimaryFirst} from "../lib/helpers";
import {shiftPropertyBadgeLabel} from "../lib/shift-property-form";
import type {ShiftProperty} from "../types";

type ShiftPropertyDisplayBadgesProps = {
  properties: readonly ShiftProperty[];
  linkable?: boolean;
  className?: string;
  badgeClassName?: string;
};

export function ShiftPropertyDisplayBadges({
  properties,
  linkable = false,
  className,
  badgeClassName,
}: ShiftPropertyDisplayBadgesProps) {
  const sorted = useMemo(() => sortShiftPropertiesPrimaryFirst(properties), [properties]);

  if (sorted.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {sorted.map((row) => {
        const isPrimary = row.assignment_type === "primary";
        const label = shiftPropertyBadgeLabel(row.property.name, row.assignment_type, {
          showRole: true,
        });

        return (
          <Badge
            key={`shift-property-display-${row.shift_property_id}`}
            variant={isPrimary ? "default" : "secondary"}
            className={cn(
              "max-w-full whitespace-normal break-words py-1 leading-snug",
              badgeClassName,
            )}
            {...(linkable ? {render: <Link to={`/properties/${row.property.id}`} />} : {})}
          >
            {label}
          </Badge>
        );
      })}
    </div>
  );
}
